import { render, staticRenderFns } from "./SidebarEvent.vue?vue&type=template&id=21fe4de7&lang=pug"
import script from "./SidebarEvent.vue?vue&type=script&lang=js"
export * from "./SidebarEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports